import React from 'react';
import {Link as RouterLink} from "react-router-dom";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';
import useSharedIsMenuOpen from "./IsMenuOpen";
import Breadcrumbs from './Breadcrumbs';

export default function NoraAppBarMobile(props) {
  const {doOpenMenu} = useSharedIsMenuOpen();

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    //changes the function state according to the value of open
    
    doOpenMenu();
  };

return (
  <>
    <Stack direction="column" sx={{mb:5,display: { xs: 'flex', md: 'none' },alignItems:"flex-start",justifyContent:"flex-start"}}>
      <Stack direction="row" spacing={4}>
        <Box sx={{ flexGrow: 1, display: { sm: 'flex', md: 'none' } }}>
          {/* hamburger icon shows the drawer on click */}
          <IconButton 
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer(true)}
              sx={{ ml: 1, display: { sm: 'block', md: 'none',}}}
          >   
            <MenuIcon />
          </IconButton>
          
          
        </Box>
        <Typography
            variant="h2"
            noWrap
            component={RouterLink}
            to="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 'bold',
              fontSize:'2.25rem',
              color: 'black',
              textDecoration: 'none',
            }}
          >
            Nora Vest
          </Typography>
      </Stack>
      <Breadcrumbs lastValue={props.title}/>
    </Stack>
 </>
)
}